module.exports = __webpack_public_path__ + "img/hot.989079b0.png";